import { render, staticRenderFns } from "./component-hixianchang.vue?vue&type=template&id=209318a6&scoped=true&"
import script from "./component-hixianchang.vue?vue&type=script&lang=js&"
export * from "./component-hixianchang.vue?vue&type=script&lang=js&"
import style0 from "./component-hixianchang.vue?vue&type=style&index=0&id=209318a6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209318a6",
  null
  
)

export default component.exports